export class CreateCantidadTipoGarantiaRequest{
public idTipoGarantia!:number
public cantidad!:number
public descripcion!: string
}
